import { haptic } from '../lib/telegram';

export type DockTab = 'home' | 'matches' | 'compete' | 'you';

interface Props {
  active: DockTab;
  onChange: (tab: DockTab) => void;
}

const TABS: Array<{ id: DockTab; label: string; icon: JSX.Element }> = [
  {
    id: 'home',
    label: 'Home',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M3 12l9-9 9 9M5 10v11h14V10" />
      </svg>
    ),
  },
  {
    id: 'matches',
    label: 'Matches',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M3 6h18M3 12h18M3 18h18" />
      </svg>
    ),
  },
  {
    id: 'compete',
    label: 'Compete',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M12 2l3 7h7l-6 4 2 8-6-5-6 5 2-8-6-4h7z" />
      </svg>
    ),
  },
  {
    id: 'you',
    label: 'You',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
      </svg>
    ),
  },
];

export function Dock({ active, onChange }: Props) {
  return (
    <nav className="dock" aria-label="Primary">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          className={`dock__item${active === tab.id ? ' is-active' : ''}`}
          onClick={() => {
            if (active !== tab.id) {
              haptic('light');
              onChange(tab.id);
            }
          }}
          aria-current={active === tab.id ? 'page' : undefined}
        >
          {tab.icon}
          <span>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
